export default __webpack_public_path__ + "static/media/giphy.db83f224.gif";